import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { RootState } from '../../../states/containers/store'
import { format, getYear, nowDate } from '../../../utils/date'
import { getGetPrams } from '../../../utils/url'

interface Props {
  date: string
  changeCallback: (date: string) => void
  closeCallback: VoidFunction
  startMonth?: string
  noLimit?: boolean
  empty?: boolean
}

interface GetParams {
  date: string
}

const MonthCalendarModal: FC<Props> = (props) => {
  const { t } = useTranslation()
  const location = useLocation()

  const {
    commonPart,
  } = useSelector((state: RootState) => state)

  const {
    date,
    changeCallback,
    closeCallback,
    startMonth,
    noLimit,
    empty,
  } = props

  const [startDate, setStartDate] = useState<string>()
  const [targetYear, setTargetYear] = useState<number>(Number(nowDate("YYYY")))

  const month = t('time.date.formats.monthName').split(' ').map((v) => v)

  const startMonthNum = useMemo(() => {
    if (startMonth) {
      return Number(startMonth)
    }
    return Number(format(commonPart.company?.created_at, 'YYYYMM'))
  }, [startMonth])

  const handleChangeMonth = (value: string | null) => {
    setStartDate(value ? format(value) : undefined)
    changeCallback(value || "")
  }

  useEffect(() => {
    if (empty) {
      setStartDate(date ? format(date) : undefined)
      setTargetYear(date ? Number(format(date, "YYYY")) : Number(nowDate("YYYY")))
      return
    }
    const getParams = getGetPrams(location.search) as GetParams
    if (!getParams.date) {
      setStartDate(date)
      setTargetYear(Number(format(date, "YYYY")))
    } else {
      setStartDate(format(getParams.date))
      setTargetYear(Number(nowDate("YYYY")))
    }
  }, [location, date])

  return (
    <>
      <div className="calendar_box">
        <div
          className="range"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            className="text"
            style={{
              margin: 0,
            }}
          >
            {t(`range.calendar.header_text.monthly`)}
          </div>
          {
            empty && (
              <>
                <button
                  type="button"
                  onClick={() => handleChangeMonth(null)}
                  style={{
                    border: "solid 1px #CCCCCC",
                    borderRadius: "4px",
                  }}
                >
                  指定なし
                </button>
              </>
            )
          }
        </div>
        <div className="monthly">
          <div className="select_month">
            <div>
              <button
                type="button"
                onClick={() => setTargetYear(targetYear - 1)}
                disabled={!noLimit && Number(format(`${startMonthNum}01`, 'YYYY')) >= targetYear}
              >
                <FontAwesomeIcon icon={['fas', 'angle-left']} />
              </button>
            </div>
            <div>
              {`${targetYear}${t('time.time.short.year')}`}
            </div>
            <div>
              <button
                type="button"
                onClick={() => setTargetYear(targetYear + 1)}
                disabled={!noLimit && getYear() <= targetYear}
              >
                <FontAwesomeIcon icon={['fas', 'angle-right']} />
              </button>
            </div>
          </div>
          {
            month.map((v, i) => {
              const targetYearDate = String(targetYear) + (`0${String(i + 1)}`).slice(-2)
              const isClickableMonth = noLimit || (
                Number(nowDate('YYYYMM')) >= Number(targetYearDate)
                && startMonthNum <= Number(targetYearDate)
              )
              const isSelected = format(startDate, 'YYYYMM') === targetYearDate
              return (
                <div className="monthly_button" key={v}>
                  <button
                    type="button"
                    className={isSelected ? "selected" : ""}
                    onClick={() => handleChangeMonth(`${String(targetYear)}-${(`0${String(i + 1)}`).slice(-2)}-01`)}
                    disabled={!isClickableMonth}
                  >
                    {`${v}${t('time.time.short.month')}`}
                  </button>
                </div>
              )
            })
          }
        </div>
      </div>
      <div className="close_screen gray" role="presentation" onClick={closeCallback} />
    </>
  )
}

MonthCalendarModal.defaultProps = {
  startMonth: "",
  noLimit: false,
  empty: false,
}

export default MonthCalendarModal
